module.exports = __webpack_public_path__ + "static/media/appartment.8440fd20.svg";